import Delete from '@mui/icons-material/Delete';
import { UploadCompaniesContext } from '../../../../../../../providers/upload-companies-provider';
import { useContext } from 'react';
import { CompanyAutocompleteOption } from '../../../../../../../types/option';
import { AutocompleteCompany } from './autocomplete-company';
import { CompanyRowStyled } from './company-row.styled';

type Props = {
    selectedCompany: CompanyAutocompleteOption;
    idx: number;
};

const CompanyRow = ({ selectedCompany, idx }: Props) => {
    const { selectedCompanies, handleDeleteValidatedCompany, handleUpdateSelectedCompany } =
        useContext(UploadCompaniesContext);
    const displayName = selectedCompanies[idx].name.charAt(0).toUpperCase() + selectedCompanies[idx].name.slice(1);

    const handleDeleteSelectedCompany = (companyName: string) => {
        handleDeleteValidatedCompany(companyName);
    };

    return (
        <CompanyRowStyled>
            <div className="company" key={`${selectedCompany}-${idx}`}>
                <div className="order">{idx + 1}</div>
                <div className="company-row">
                    <div className="input left">
                        <div className="name">{displayName}</div>
                    </div>
                    <div className="input right">
                        <AutocompleteCompany
                            suggestion={{
                                id: selectedCompany.id,
                                name: selectedCompany.name,
                                website: selectedCompany.website,
                                industry: selectedCompany.industry,
                                isValid: selectedCompany.isValid,
                            }}
                            idx={idx}
                            updateSelection={handleUpdateSelectedCompany}
                        />
                    </div>
                </div>
                <div className="action" onClick={() => handleDeleteSelectedCompany(selectedCompany.name)}>
                    <Delete />
                </div>
            </div>
        </CompanyRowStyled>
    );
};

export default CompanyRow;
